import React from 'react'
import Text from '../text'
import Flex from '../flex'
import Button from '../button'
import DeleteIcon from '../svg/delete'
import EditIcon from '../svg/editIcon'
import CheckIcon from "../svg/checkIcon";
import Xicon from "../svg/xIcon";



const VehicleDetailCard = (props) => {
    const {make, model, color, licensePlateState, licensePlateNumber, onDelete, onEdit, isElectric} = props
    return (
        <div className="vehicle-detail-card">
            <div className="action-buttons">
                <Button 
                    type="button" 
                    className="vdc-item-btn-edit" 
                    linkInfo 
                    text={<EditIcon />}
                    onClick={onEdit}
                />
                <Button 
                    type="button" 
                    className="vdc-item-btn-delete" 
                    linkDanger 
                    text={<DeleteIcon />}
                    onClick={onDelete}
                />
            </div>
            <Flex alignItemsCenter className="vdc-item">
                <Text type="LABEL" className="vdc-label" text="Make:" />
                <Text type="SPAN" className="vdc-text" text={make} />
            </Flex>
            <Flex alignItemsCenter className="vdc-item">
                <Text type="LABEL" className="vdc-label" text="Model:" />
                <Text type="SPAN" className="vdc-text" text={model} />
            </Flex>
            <Flex alignItemsCenter className="vdc-item">
                <Text type="LABEL" className="vdc-label" text="Color:" />
                <Text type="SPAN" className="vdc-text" text={color} />
            </Flex>
            <Flex alignItemsCenter className="vdc-item">
                <Text type="LABEL" className="vdc-label" text="License Plate State:" />
                <Text type="SPAN" className="vdc-text" text={licensePlateState} />
            </Flex>
            <Flex alignItemsCenter className="vdc-item">
                <Text type="LABEL" className="vdc-label" text="License Plate Number:" />
                <Text type="SPAN" className="vdc-text" text={licensePlateNumber} />
            </Flex>
            <Flex alignItemsCenter className="vdc-item">
                <Text type="LABEL" className="vdc-label" text="Is this an Electric Vehicle (EV)?" />
                <div className="vdc-text">{isElectric ? <CheckIcon title="Yes" width="16" height="16" /> : <Xicon title="No" width="16" height="16"/>}</div>
            </Flex>
        </div>
    )
}

export default VehicleDetailCard